import jwtDecode from 'jwt-decode';
import { actions as authActions } from 'store/auth';
import { Action, Middleware } from 'redux';

// eslint-disable-next-line consistent-return, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
const tokenMiddleware: Middleware = (store: any) => (next: Function) => (action: Action) => {
  const blacklist = ['LOGIN', 'RESET_PASSWORD', 'REQUEST_RESET_PASSWORD'];
  const shouldBlacklist = blacklist.reduce((acc, type) => acc || action.type.includes(type), false);

  if (action.type.includes('REQUEST') && !shouldBlacklist) {
    const token = store.getState().auth.token;

    if (!!token) {
      const jwtToken = jwtDecode<{ [x: string]: string | number }>(token);
      if (Number(jwtToken.exp) < Date.now() / 1000) return store.dispatch(authActions.logout());
    } else {
      return store.dispatch(authActions.logout());
    }
  }
  next(action);
};

export default tokenMiddleware;
